import { isAfter } from 'date-fns';
import { StudyParticipantQueryData } from '../hooks/study-participant/useQueryStudyParticipantData';

export function mergeMedicationSurveyData(
  surveyData: StudyParticipantQueryData<Record<any, any>>[][]
) {
  const res = surveyData;
  res.forEach((data, index) => {
    const result: StudyParticipantQueryData<Record<any, any>>[] = [];
    data.forEach(obj => {
      let found = false;
      for (let i = 0; i < result.length; i++) {
        if (
          result[i].intendedStartDate.toString() ===
          obj.intendedStartDate.toString()
        ) {
          found = true;
          Object.entries(obj).forEach(([key, value]) => {
            if (
              typeof result[i][key] !== 'undefined' &&
              result[i][key] !== null
            ) {
              if (
                typeof value !== 'undefined' &&
                value !== null &&
                obj.completedDate &&
                result[i].completedDate &&
                isAfter(obj.completedDate, result[i].completedDate)
              ) {
                result[i][key] = value;
              }
            } else {
              result[i][key] = value;
            }
          });
          break;
        }
      }
      if (!found) {
        result.push({ ...obj });
      }
    });
    result.sort(
      (a, b) => a.intendedStartDate.getTime() - b.intendedStartDate.getTime()
    );
    res[index] = result;
  });
  return res;
}
